import type { ConfigProviderProps } from "antd";

/** 管理后台原生 Ant Design 弹窗遵循旧版确认框的全局居中行为。 */
export const adminModalConfig = {
    centered: true
} satisfies NonNullable<ConfigProviderProps["modal"]>;
